import type { SponsorConfig } from '../shared/tokens/sponsor-config.types'
import type { SocialPlatform } from '../components/PlatformIcon'

export const MASTER_HERO_SOCIAL_LINKS: Array<{
  platform: SocialPlatform
  href: string
  label: string
}> = [
  { platform: 'facebook', href: 'https://www.facebook.com/share/1Fsrsuqz3q/?mibextid=wwXIfr', label: 'Facebook' },
  { platform: 'youtube', href: 'https://youtube.com/@rizrazak', label: 'YouTube' },
  { platform: 'tiktok', href: 'https://www.tiktok.com/@riz.razak', label: 'TikTok' },
  { platform: 'instagram', href: 'https://www.instagram.com/riz_razak_/', label: 'Instagram' },
]

export const MASTER_AUDIENCE_FALLBACK: SponsorConfig = {
  _external_disclosure_policy: 'silent',
  slug: 'master',
  name: 'Yan-Vada Master Pitch',
  tier: 'master_pitch_audience',
  brand: {
    primary_colour: '#2E2B26',
    accent_colour: '#E88D2A',
    background_preference: 'dark',
    logo_asset: 'yan-vada-wordmark-placeholder.svg',
    logo_alt: 'Yan-Vada wordmark',
    typography_override: { headline_font: 'Inter', body_font: 'Inter' },
  },
  content: {
    hero_headline: 'Partnership Proposal: Yan-Vada (යන්-වාද)',
    hero_subhead: 'Season 01 Partnership Proposal',
    sections: [
      {
        id: 'opening-register',
        type: 'text',
        heading: 'The people moving the culture sit down on a Mount Lavinia balcony before the noise catches up.',
        body: 'Yan-Vada is a digital interview for social media. Relaxed attitude, high-octane topics, fast-paced in the edit. Eight episodes, recorded on a balcony in Mount Lavinia across the rest of 2026.\n\nA video-first show hosted by Riz Razak. Season 01 is moving from pilot assets into public release.\n\nThe idea: bridge the gap between the known and the patterns in industries and personal stories.',
      },
    ],
  },
  contact: { sponsor_contact_internal: [], reply_to: 'riz@dgtl.lk' },
  tracking: { analytics_enabled: true, campaign_id: 'master-pitch-audience' },
}

export function buildAudienceSponsorConfig(config: SponsorConfig) {
  const introSection = config.content.sections.find((section) => section.type === 'text') ?? MASTER_AUDIENCE_FALLBACK.content.sections[0]
  return {
    ...config,
    slug: 'master',
    content: {
      ...config.content,
      hero_sponsor_logo: undefined,
      hero_sponsor_name: undefined,
      sections: introSection ? [introSection] : [],
      why_fit: [],
      cta: undefined,
    },
  }
}
